const doc = [({"en":({"js":({"users":({"confirmation":({"new":({"the_confirmation_email_was_sent_again":"The confirmation email was sent again."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;